<template>
    <div class="login">
        <div class="row row--fullwidth">
            <div class="col lg-6 sm-12">
                <LoginForm />
            </div>
            <div class="col lg-6 sm-12 col--no-padding login-img">
                <UiImage :path="img" :desktop="{ width: 1016 }" :lazy="false" />
            </div>
        </div>
    </div>
</template>
<script>
import LoginForm from "~/components/LoginForm";
import { mapGetters } from "vuex";
import UiImage from "../../components/ui/Image.vue";

export default {
    name: "Login",
    components: {
        UiImage,
        LoginForm,
    },
    async asyncData({ $axios }) {
        try {
            return {
                img: (await $axios.get("/api/page-images/login")).data.img,
            };
        } catch (e) {
            console.log(e);
        }
    },
    data() {
        return {
            img: null,
        };
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
    },
    methods: {
        getCrumbs() {
            return [
                {
                    name: this.$i18n.t("lk_auth"),
                },
            ];
        },
    },
    watch: {
        langust() {
            this.$store.commit("crumbs/change", this.getCrumbs());
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.getCrumbs());
    },
};
</script>
<style lang="less" scoped>
.social-login {
    margin-top: 80px;
    padding-bottom: 20px;
    @media @sm {
        margin-top: 0;
    }
}

.login {
    z-index: 1;
    background: #fff;

    &-img {
        img {
            width: 100%;
        }
    }
}
</style>
